import { render, staticRenderFns } from "./ClientTestimonials.vue?vue&type=template&id=6d69f6f6&scoped=true&"
import script from "./ClientTestimonials.vue?vue&type=script&lang=js&"
export * from "./ClientTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ClientTestimonials.vue?vue&type=style&index=0&id=6d69f6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69f6f6",
  null
  
)

export default component.exports